module.exports = __webpack_public_path__ + "static/technical-controls-d840302adad1c2b2fd570d90085f326d.svg";